import { useCallback, useEffect, useRef, useState } from 'react';

// The Cylindo viewer takes a moment to boot, and the gallery would otherwise go
// blank while it does. This layers the photo that was showing when the viewer
// activated above it, then fades it out once the viewer reports loaded
// (CON-8444).
const useCylindoBootOverlay = ({
  isViewerActive,
  photo
}) => {
  const [isViewerReady, setIsViewerReady] = useState(false);
  const onViewerLoaded = useCallback(() => setIsViewerReady(true), []);
  const lastPhotoRef = useRef(null);
  useEffect(() => {
    if (!isViewerActive && photo?.src) {
      lastPhotoRef.current = photo;
    }
  }, [isViewerActive, photo]);

  // The viewer's loaded event does not always arrive. Fade the overlay anyway
  // after 4s, so it can never sit on top of the viewer permanently.
  useEffect(() => {
    if (!isViewerActive || isViewerReady) {
      return undefined;
    }
    const timer = setTimeout(() => setIsViewerReady(true), 4000);
    return () => clearTimeout(timer);
  }, [isViewerActive, isViewerReady]);
  return {
    overlayPhoto: isViewerActive ? lastPhotoRef.current : null,
    isViewerReady,
    onViewerLoaded
  };
};
export default useCylindoBootOverlay;